var viewer_default = {
  "gallery_container": "C7V-f",
  "imageTitleContainer": "t4yfd",
  "clickableItem": "_4Kb2D",
  "prerender": "GIL2j",
  "expandButton": "y0OWo",
  "itemContainer": "-lw7u",
  "expandIcon": "_6doL9",
  "itemOverlay": "_3M4iJ",
  "imageTitle": "uGdBe",
  "pointer": "DbvLA",
  "fadeIn": "_8V8Zv",
  "changing_background": "IAhg-"
};
export {
  viewer_default as default
};
//# sourceMappingURL=viewer-scss.js.map
